import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { PageSettings } from '../../config/page-settings.js';
import Stepper from '../../components/Stepper';
import StepContainer from './components/StepContainer';
import UserForm from './components/UserForm';
import OrganizationForm from './components/OrganizationForm';
import SuccessScreen from './components/SuccessScreen';

const Register = () => {
  const context = useContext(PageSettings);
  const history = useHistory();
  
  // State for multi-step
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    nombre: '',
    apellidoPaterno: '',
    apellidoMaterno: '',
    email: '',
    telefono: '',
    password: '',
    confirmPassword: '',
    // Step 2 fields
    organizacionNombre: '',
    organizacionRFC: '',
    organizacionTipoEntidad: '',
    organizacionDireccion: '',
    organizacionEstado: '',
    organizacionPais: 'mexico',
    organizacionTelefono: '',
    organizacionLogotipo: null,
    // Step 3 fields
    configProducto: '',
    configCertificaciones: [],
    configModulos: [],
    configPrivacidadTerminos: false
  });
  
  // State for UI toggles
  const [typePassword, setTypePassword] = useState('password');
  const [typeConfirm, setTypeConfirm] = useState('password');

  useEffect(() => {
    context.handleSetPageSidebar(false);
    context.handleSetPageHeader(false);
    context.handleSetBodyWhiteBg(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (fieldName, value) => {
    setFormData(prev => {
      const currentValues = prev[fieldName] || [];
      const newValues = currentValues.includes(value)
        ? currentValues.filter(v => v !== value)
        : [...currentValues, value];
      return { ...prev, [fieldName]: newValues };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(`Datos de registro paso ${currentStep}:`, formData);
    
    if (currentStep < 3) {
      setCurrentStep(currentStep + 1);
    } else {
      // Final submission (Step 4 is the last for now)
      console.log("Registro completo:", formData);
    }
  };

  const togglePassword = () => setTypePassword(prev => prev === 'password' ? 'text' : 'password');
  const toggleConfirm = () => setTypeConfirm(prev => prev === 'password' ? 'text' : 'password');

  const handleBack = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const isStepValid = () => {
    switch (currentStep) {
      case 1:
        return !!(formData.nombre && formData.apellidoPaterno && formData.apellidoMaterno &&
                  formData.email && formData.telefono && formData.password && formData.confirmPassword &&
                  formData.password === formData.confirmPassword);
      case 2:
        return !!(formData.organizacionNombre && formData.organizacionPais &&
                  formData.configProducto && formData.configPrivacidadTerminos);
      case 3:
        return true;
      default:
        return true;
    }
  };

  const steps = [
    {
      id: 1,
      title: '¡Te damos la bienvenida a Sirio!',
      subtitle: 'Registra la cuenta de tu cooperativa o empresa en menos de 5 minutos y forma parte de los miles de productores que están digitalizando sus operaciones.',
      component: UserForm
    },
    {
      id: 2,
      title: 'Datos de tu Organización',
      subtitle: 'Configura la identidad y ubicación de tu cooperativa o empresa.',
      component: OrganizationForm
    },
    {
      id: 3,
      component: SuccessScreen,
    }
  ];

  const currentStepData = steps[currentStep - 1] || steps[0];
  const CurrentStepComponent = currentStepData.component;

  return (
    <div className="login p-0" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 1rem' }}>
      <div className="card shadow-sm border-0" style={{ width: '100%', maxWidth: '900px', borderRadius: '15px' }}>
        <div className="card-body p-sm-5 p-32">
          
          <Stepper currentStep={currentStep} totalSteps={steps.length} />

          <StepContainer
            currentStep={currentStep}
            totalSteps={steps.length}
            title={currentStepData.title}
            subtitle={currentStepData.subtitle}
            onSubmit={handleSubmit}
            onBack={handleBack}
            buttonText={currentStepData.buttonText}
            buttonClass={currentStepData.buttonClass}
            isValid={isStepValid()}
          >
            <CurrentStepComponent
              formData={formData}
              handleChange={handleChange}
              handleCheckboxChange={handleCheckboxChange}
              togglePassword={togglePassword}
              toggleConfirm={toggleConfirm}
              typePassword={typePassword}
              typeConfirm={typeConfirm}
            />
          </StepContainer>

        </div>
      </div>
    </div>
  );
};

export default Register;